import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'prix'
})
export class PrixPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
